import LoadingAtom from "@/components/loadingAtom/LoadingAtom";
import HENGE from "@henge-inc/global-types";
import { i as i_v1_1 } from "@henge-inc/ui/v1_1";
import HUI from "@henge-inc/ui/v1_2";
import { motion } from "motion/react";

interface UploadModalStatusPageProps {
  uploadLoading: boolean;
  uploadComplete: boolean;
  uploadFailed: boolean;
}

export const UploadModalStatusPage = ({
  uploadLoading,
  uploadComplete,
  uploadFailed,
}: UploadModalStatusPageProps) => {
  if (uploadFailed) {
    return (
      <>
        <motion.div
          className="flex flex-col items-center justify-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <i_v1_1.Forbidden
            kind={HENGE.ICON_KIND.regular}
            colour={HENGE.MAIN_COLOUR.red200}
            size={HENGE.DETAILED_SIZE.x3Large}
          />
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <HUI.Text
              kind={HENGE.TEXT_KIND.body1}
              weight={HENGE.TEXT_WEIGHT.medium}
              className="mt-4"
            >
              업로드 실패
            </HUI.Text>
          </motion.div>
        </motion.div>
      </>
    );
  }

  if (uploadComplete) {
    return (
      <>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <i_v1_1.CheckCircle
            kind={HENGE.ICON_KIND.regular}
            colour={HENGE.MAIN_COLOUR.green200}
            size={HENGE.DETAILED_SIZE.x3Large}
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <HUI.Text
            kind={HENGE.TEXT_KIND.body1}
            weight={HENGE.TEXT_WEIGHT.medium}
            className="mt-4"
          >
            업로드 완료!
          </HUI.Text>
        </motion.div>
      </>
    );
  }

  if (uploadLoading) {
    return (
      <>
        <motion.div
          className="inset-0 flex items-center justify-center z-10"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <LoadingAtom width={160} height={160} />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <HUI.Text
            kind={HENGE.TEXT_KIND.body1}
            weight={HENGE.TEXT_WEIGHT.medium}
            className="mt-4"
          >
            업로드 중...
          </HUI.Text>
        </motion.div>
      </>
    );
  }

  return null;
};
